(() => {
  const SCRIPT_SELECTOR = 'script[data-product-pricing-properties]';

  const stateBySection = new Map();
  let variantChangeUnsubscriber = null;

  const normalizeString = (value) => `${value ?? ''}`;

  const parseScriptPayload = (script) => {
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (error) {
      console.warn('Failed to parse product pricing properties payload.', error);
      return null;
    }
  };

  const registerScripts = (root = document) => {
    const scripts = root.querySelectorAll ? root.querySelectorAll(SCRIPT_SELECTOR) : [];
    scripts.forEach((script) => {
      const payload = parseScriptPayload(script);
      const sectionId = payload && payload.sectionId != null ? normalizeString(payload.sectionId) : '';
      if (!sectionId) {
        return;
      }
      stateBySection.set(sectionId, payload);
    });
  };

  const getBaseJpyValue = (sectionId, variantId) => {
    const payload = stateBySection.get(normalizeString(sectionId));
    if (!payload || !payload.baseJpyByVariant) {
      return '';
    }

    const rawValue = payload.baseJpyByVariant[normalizeString(variantId)];
    return rawValue == null ? '' : normalizeString(rawValue);
  };

  const syncSectionInput = (sectionId, variantId) => {
    const normalizedSectionId = normalizeString(sectionId);
    const input = document.querySelector(
      `[data-product-pricing-properties-input="${CSS.escape(normalizedSectionId)}"]`
    );

    if (!input) {
      return;
    }

    input.value = getBaseJpyValue(normalizedSectionId, variantId);
  };

  const syncInitialValues = () => {
    stateBySection.forEach((_, sectionId) => {
      const form = document.getElementById(`product-form-${sectionId}`);
      const variantIdInput = form ? form.querySelector('[name="id"]') : null;
      if (!variantIdInput) {
        return;
      }

      syncSectionInput(sectionId, variantIdInput.value);
    });
  };

  const bindVariantChange = () => {
    if (variantChangeUnsubscriber) {
      return;
    }

    if (
      typeof subscribe !== 'function' ||
      typeof PUB_SUB_EVENTS === 'undefined' ||
      !PUB_SUB_EVENTS.productVariantChange
    ) {
      return;
    }

    variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productVariantChange, (eventData) => {
      const sectionId = eventData && eventData.sectionId != null ? eventData.sectionId : null;
      const variantId =
        eventData && eventData.variant && eventData.variant.id != null ? eventData.variant.id : null;

      if (sectionId == null || variantId == null) {
        return;
      }

      syncSectionInput(sectionId, variantId);
    });
  };

  const initialize = (root = document) => {
    registerScripts(root);
    syncInitialValues();
    bindVariantChange();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initialize(document);
      },
      { once: true }
    );
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target || document);
  });
})();
